module.exports = __webpack_public_path__ + "img/World.a5893435.svg";